// Store Locator Script with Leaflet & OpenStreetMap
let map;
let markers = [];
let storeList = [];
let markerClusterGroup;
let geocoder;
let searchTimeout;
let loadingDiv;

// Default map center (Massachusetts center)
const defaultCenter = { lat: 42.4072, lng: -71.3824 };

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
  // Wait a short time to ensure Firebase is fully loaded
  setTimeout(() => {
    initMap();
    setupSearchFilters();
    setupSearchButton();
  }, 500);
});

// Initialize the map
function initMap() {
  console.log("Initializing map with Massachusetts center");
  
  // Get map element
  const mapElement = document.getElementById('store-locator-map');
  if (!mapElement) {
    console.error('Map element not found');
    return;
  }
  
  // Add loading indicator
  loadingDiv = document.createElement('div');
  loadingDiv.className = 'map-loading';
  loadingDiv.textContent = 'Loading map...';
  mapElement.appendChild(loadingDiv);
  
  try {
    // Create Leaflet map
    map = L.map('store-locator-map').setView([defaultCenter.lat, defaultCenter.lng], 8);
    
    // Add OpenStreetMap tile layer
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(map);
    
    // Initialize marker cluster group
    markerClusterGroup = L.markerClusterGroup({
      maxClusterRadius: 50,
      spiderfyOnMaxZoom: true,
      showCoverageOnHover: false,
      zoomToBoundsOnClick: true
    });
    map.addLayer(markerClusterGroup);
    
    // Set up geocoder
    geocoder = L.Control.Geocoder.nominatim();
    
    // Add Massachusetts marker
    const maMarker = L.marker([defaultCenter.lat, defaultCenter.lng], {
      title: "Massachusetts",
      icon: L.divIcon({
        className: 'default-marker',
        html: '<div style="background-color: #3388ff; width: 12px; height: 12px; border-radius: 50%; border: 2px solid white;"></div>',
        iconSize: [16, 16],
        iconAnchor: [8, 8]
      })
    }).addTo(map);
    
    // Bind popup to Massachusetts marker but don't open it by default
    maMarker.bindPopup("<b>Massachusetts</b>");
    
    // Save reference to Massachusetts marker
    window.massachusettsMarker = maMarker;
    
    // Ensure Massachusetts is focused
    focusOnMassachusetts();
    
    // Remove loading indicator after a timeout
    setTimeout(() => {
      if (loadingDiv && loadingDiv.parentNode) {
        loadingDiv.parentNode.removeChild(loadingDiv);
      }
    }, 2000);
    
    // Initialize Firebase if needed
    initializeFirebase();
    
  } catch (error) {
    console.error('Error initializing map:', error);
    mapElement.innerHTML = '<div style="text-align: center; padding: 20px;">Error loading map. Please try again later.</div>';
  }
}

// Focus map on Massachusetts and show popup
function focusOnMassachusetts() {
  if (map) {
    // Center map on Massachusetts
    map.setView([defaultCenter.lat, defaultCenter.lng], 8);
    
    // We're intentionally not opening the popup anymore
    // if (window.massachusettsMarker) {
    //   window.massachusettsMarker.openPopup();
    // }
  }
}

// Make function globally accessible
window.focusOnMassachusetts = focusOnMassachusetts;

// Setup search button and ZIP code functionality
function setupSearchButton() {
  const searchButton = document.getElementById('store-search-button');
  const searchInput = document.getElementById('store-search-input');
  
  if (!searchButton || !searchInput) return;
  
  // Add click event to search button
  searchButton.addEventListener('click', function() {
    searchByLocation();
  });
  
  // Add enter key event to search input
  searchInput.addEventListener('keypress', function(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      searchByLocation();
    }
  });
}

// Setup filters
function setupSearchFilters() {
  const stateFilter = document.getElementById('state-filter');
  const distanceFilter = document.getElementById('distance-filter');
  
  if (!stateFilter) return;
  
  // Hide distance filter since we're removing location functionality
  if (distanceFilter) {
    distanceFilter.parentNode.removeChild(distanceFilter);
  }
  
  // Populate state filter when store data is loaded
  function populateStateFilter() {
    if (!storeList || storeList.length === 0) return;
    
    // Get unique states
    const states = [...new Set(storeList.map(store => store.state))].sort();
    
    // Clear existing options (except first)
    while (stateFilter.options.length > 1) {
      stateFilter.remove(1);
    }
    
    // Add state options
    states.forEach(state => {
      const option = document.createElement('option');
      option.value = state;
      option.textContent = state;
      stateFilter.appendChild(option);
    });
  }
  
  // Add event listeners
  stateFilter.addEventListener('change', filterStores);
  
  // Filter stores based on selected filters
  function filterStores() {
    const selectedState = stateFilter.value;
    
    // If no filters are active, show all stores
    if (!selectedState) {
      displayStores(storeList);
      return;
    }
    
    // Filter by state
    let filteredStores = storeList;
    if (selectedState) {
      filteredStores = filteredStores.filter(store => store.state === selectedState);
    }
    
    // Display filtered stores
    displayStores(filteredStores);
  }
  
  // Export for later use
  window.populateStateFilter = populateStateFilter;
}

// Initialize Firebase if it's not already initialized
function initializeFirebase() {
  // Check if Firebase is defined
  if (typeof firebase === 'undefined') {
    console.error('Firebase is not defined');
    const storeListElement = document.getElementById('store-list');
    if (storeListElement) {
      storeListElement.innerHTML = 
        '<div class="store-list-loading">Error: Firebase SDK not loaded. Please check your internet connection and try again.</div>';
    }
    return;
  }
  
  // Check if Firebase is already initialized
  if (!firebase.apps.length) {
    try {
      const firebaseConfig = {
        apiKey: "AIzaSyCc9sZL9h8NdRms9F5u-V7EcNCptg-OJDE",
        authDomain: "washnaturals-36b75.firebaseapp.com",
        databaseURL: "https://washnaturals-36b75-default-rtdb.firebaseio.com",
        projectId: "washnaturals-36b75",
        storageBucket: "washnaturals-36b75.firebasestorage.app",
        messagingSenderId: "776912885702",
        appId: "1:776912885702:web:391e3cdf4d6045a3b344c7",
        measurementId: "G-YXKHE3X1LB"
      };
      firebase.initializeApp(firebaseConfig);
      console.log("Firebase initialized from store-locator.js");
    } catch (error) {
      console.error('Error initializing Firebase:', error);
      const storeListElement = document.getElementById('store-list');
      if (storeListElement) {
        storeListElement.innerHTML = 
          '<div class="store-list-loading">Error initializing Firebase. Please try again later.</div>';
      }
      return;
    }
  }
  
  // Initialize Firestore
  if (!window.db) {
    try {
      window.db = firebase.firestore();
      console.log("Firestore initialized");
      
      // Load store data after initialization
      loadStoreData();
    } catch (error) {
      console.error('Error initializing Firestore:', error);
      const storeListElement = document.getElementById('store-list');
      if (storeListElement) {
        storeListElement.innerHTML = 
          '<div class="store-list-loading">Error initializing database. Please try again later.</div>';
      }
    }
  } else {
    // Load store data if Firestore is already initialized
    loadStoreData();
  }
}

// Load store data from Firebase
function loadStoreData() {
  console.log("Loading store data from Firestore");
  
  // Show loading message
  const storeListElement = document.getElementById('store-list');
  if (storeListElement) {
    storeListElement.innerHTML = 
      '<div class="store-list-loading">Loading store locations...</div>';
  }
  
  // Check if Firestore is available
  if (!window.db) {
    console.error('Firestore is not initialized');
    if (storeListElement) {
      storeListElement.innerHTML = 
        '<div class="store-list-loading">Error: Database not initialized. Please try again later.</div>';
    }
    return;
  }
  
  // Fetch data from Firestore
  window.db.collection('store-locations')
    .orderBy('name', 'asc')
    .get()
    .then((snapshot) => {
      console.log(`Retrieved ${snapshot.size} stores from Firestore`);
      storeList = [];
      
      if (snapshot.empty) {
        console.log('No store locations found');
        if (storeListElement) {
          storeListElement.innerHTML = 
            '<div class="store-list-loading">No store locations found. Please check back later.</div>';
        }
        
        // Update store count display
        updateStoreCount(0);
        
        return;
      }
      
      snapshot.forEach((doc) => {
        const store = doc.data();
        console.log('Store data:', store);
        storeList.push({
          id: doc.id,
          name: store.name,
          address: store.address,
          city: store.city,
          state: store.state,
          zip: store.zip,
          country: store.country || 'USA',
          phone: store.phone || '',
          website: store.website || '',
          description: store.description || '',
          lat: parseFloat(store.lat),
          lng: parseFloat(store.lng)
        });
      });
      
      console.log(`Processed ${storeList.length} stores`);
      
      // Update store count display
      updateStoreCount(storeList.length);
      
      // Populate state filter
      if (window.populateStateFilter) {
        window.populateStateFilter();
      }
      
      // Display the stores
      displayStores(storeList);
      
      // Remove loading indicator if it still exists
      if (loadingDiv && loadingDiv.parentNode) {
        loadingDiv.parentNode.removeChild(loadingDiv);
      }
    })
    .catch((error) => {
      console.error('Error loading store data:', error);
      if (storeListElement) {
        storeListElement.innerHTML = 
          `<div class="store-list-loading">Error loading store locations: ${error.message}</div>`;
      }
      
      // Update store count display with error
      updateStoreCount(0);
    });
}

// Update the store count display
function updateStoreCount(count) {
  const countElement = document.getElementById('store-count');
  if (countElement) {
    countElement.textContent = count;
  }
}

// Display stores on map and in list
function displayStores(stores) {
  console.log(`Displaying ${stores ? stores.length : 0} stores`);
  
  // Clear existing markers
  markerClusterGroup.clearLayers();
  markers = [];
  
  // Clear store list
  const storeListElement = document.getElementById('store-list');
  if (!storeListElement) {
    console.error("Store list element not found");
    return;
  }
  
  storeListElement.innerHTML = '';
  
  // If no stores, show message
  if (!stores || stores.length === 0) {
    console.log("No stores to display");
    storeListElement.innerHTML = 
      '<div class="store-list-loading">No store locations found.</div>';
    
    // Focus on Massachusetts when no stores
    focusOnMassachusetts();
    
    return;
  }
  
  // Sort stores by name
  stores.sort((a, b) => a.name.localeCompare(b.name));
  
  // Create bounds for auto-zooming
  const bounds = L.latLngBounds();
  bounds.extend([defaultCenter.lat, defaultCenter.lng]);
  
  // Add each store to map and list
  stores.forEach((store, index) => {
    if (isNaN(store.lat) || isNaN(store.lng)) {
      console.error(`Invalid coordinates for store: ${store.name}`, store.lat, store.lng);
      return;
    }
    
    // Create marker and add to cluster group
    const marker = createMarker(store, index);
    markerClusterGroup.addLayer(marker);
    markers.push(marker);
    
    // Add to list
    if (store.distance !== undefined) {
      addStoreToListWithDistance(store, index);
    } else {
      addStoreToList(store, index);
    }
    
    // Extend bounds
    bounds.extend([store.lat, store.lng]);
  });
  
  // Fit map to bounds
  if (stores.length > 0 && map) {
    map.fitBounds(bounds, { padding: [30, 30] });
  }
}

// Create a marker for a store
function createMarker(store, index) {
  const marker = L.marker([store.lat, store.lng], {
    title: store.name
  });
  
  // Create Google Maps directions URL
  const directionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
    `${store.address}, ${store.city}, ${store.state} ${store.zip}`
  )}`;
  
  // Create popup content
  const content = `
    <div class="map-info-window">
      <h3>${store.name}</h3>
      <p>${store.address}<br>${store.city}, ${store.state} ${store.zip}</p>
      ${store.phone ? `<p>Phone: ${store.phone}</p>` : ''}
      ${store.website ? `<p><a href="${store.website}" target="_blank">Visit Website</a></p>` : ''}
      ${store.description ? `<p>${store.description}</p>` : ''}
      <p><a href="${directionsUrl}" target="_blank" class="directions-button">Get Directions</a></p>
    </div>
  `;
  
  // Bind popup to marker
  marker.bindPopup(content, {
    maxWidth: 300,
    minWidth: 250
  });
  
  // Add click event
  marker.on('click', function() {
    // Highlight corresponding list item
    const listItems = document.querySelectorAll('.store-item');
    if (listItems.length > index) {
      listItems.forEach(item => item.classList.remove('active'));
      listItems[index].classList.add('active');
      listItems[index].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
    
    // Open popup
    marker.openPopup();
  });
  
  return marker;
}

// Add a store to the list
function addStoreToList(store, index) {
  try {
    const storeListElement = document.getElementById('store-list');
    if (!storeListElement) return;
    
    // Create a unique display ID for the store (using the first 4 characters of the ID)
    const displayId = store.id ? `ID: ${store.id.substring(0, 4)}...` : `Item #${index+1}`;
    
    // Create Google Maps directions URL
    const directionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
      `${store.address}, ${store.city}, ${store.state} ${store.zip}`
    )}`;
    
    const storeItem = document.createElement('div');
    storeItem.className = 'store-item';
    storeItem.id = `store-item-${index}`;
    
    storeItem.innerHTML = `
      <h3>${store.name}</h3>
      <p>${store.address}<br>${store.city}, ${store.state} ${store.zip}</p>
      ${store.phone ? `<p>Phone: ${store.phone}</p>` : ''}
      ${store.website ? `<p><a href="${store.website}" target="_blank">Visit Website</a></p>` : ''}
      <p><a href="${directionsUrl}" target="_blank" class="directions-button">Get Directions</a></p>
    `;
    
    // Add click event to list item
    storeItem.addEventListener('click', function() {
      // Remove active class from all items
      document.querySelectorAll('.store-item').forEach(item => {
        item.classList.remove('active');
      });
      
      // Add active class to clicked item
      storeItem.classList.add('active');
      
      // Center map on this store
      if (map) {
        map.setView([store.lat, store.lng], 14);
      }
      
      // Open marker popup
      if (markers.length > index) {
        markers[index].openPopup();
      }
    });
    
    storeListElement.appendChild(storeItem);
  } catch (error) {
    console.error(`Error adding store ${store.name} to list:`, error);
  }
}

// Search for stores by location
function searchByLocation() {
  // Get input value
  const input = document.getElementById('store-search-input');
  if (!input) return;
  
  const query = input.value.trim();
  if (!query) {
    // If empty, show all stores and focus on Massachusetts
    displayStores(storeList);
    focusOnMassachusetts();
    return;
  }
  
  // Show loading
  const storeListElement = document.getElementById('store-list');
  if (storeListElement) {
    storeListElement.innerHTML = 
      '<div class="store-list-loading">Searching...</div>';
  }
  
  // Check if it's a ZIP code (5 digits)
  const zipRegex = /^\d{5}$/;
  if (zipRegex.test(query)) {
    console.log("Searching by ZIP code:", query);
    
    // Search directly in our store list by ZIP
    const matchingStores = storeList.filter(store => 
      store.zip === query || store.zip.startsWith(query)
    );
    
    if (matchingStores.length > 0) {
      console.log(`Found ${matchingStores.length} stores matching ZIP code ${query}`);
      displayStores(matchingStores);
    } else {
      displayNoResults(query);
    }
    return;
  }
  
  // Search by city, state, name
  const lowercaseQuery = query.toLowerCase();
  
  // Search by name, city, state, or zip
  const filteredStores = storeList.filter(store => 
    store.name.toLowerCase().includes(lowercaseQuery) ||
    store.city.toLowerCase().includes(lowercaseQuery) ||
    store.state.toLowerCase().includes(lowercaseQuery) ||
    store.zip.includes(lowercaseQuery)
  );
  
  // Display filtered stores
  if (filteredStores.length > 0) {
    console.log(`Found ${filteredStores.length} stores matching search for "${query}"`);
    displayStores(filteredStores);
  } else {
    displayNoResults(query);
  }
}

// Display a friendly message when no results are found
function displayNoResults(query) {
  const storeListElement = document.getElementById('store-list');
  if (!storeListElement) return;
  
  storeListElement.innerHTML = `
    <div class="store-list-no-results">
      <h3>No retailers found in "${query}" yet!</h3>
      <p>We're expanding to more locations all the time. Please check back soon, or try searching for a different area.</p>
      <p>In the meantime, you can always shop our products online!</p>
      <a href="/collections/all" class="no-results-shop-button">Shop Now</a>
    </div>
  `;
  
  // Focus on Massachusetts when no results
  focusOnMassachusetts();
}

// Display stores with distance from search location
function displayStoresWithDistance(searchLocation) {
  console.log("Calculating distances from search location:", searchLocation);
  
  try {
    // Convert to L.latLng if not already
    const latLng = searchLocation instanceof L.LatLng 
      ? searchLocation 
      : L.latLng(searchLocation.lat, searchLocation.lng);
    
    // Calculate distance for each store
    const storesWithDistance = storeList.map(store => {
      if (isNaN(store.lat) || isNaN(store.lng)) {
        return { ...store, distance: Infinity };
      }
      
      const storeLatLng = L.latLng(store.lat, store.lng);
      const distance = storeLatLng.distanceTo(latLng) / 1609.34; // Convert meters to miles
      
      return {
        ...store,
        distance: distance
      };
    });
    
    // Sort by distance
    storesWithDistance.sort((a, b) => a.distance - b.distance);
    
    // Filter stores within 100 miles
    const nearbyStores = storesWithDistance.filter(store => store.distance <= 100);
    
    console.log(`Found ${nearbyStores.length} stores within 100 miles`);
    
    // Clear existing markers
    markerClusterGroup.clearLayers();
    markers = [];
    
    // Clear store list
    const storeListElement = document.getElementById('store-list');
    if (!storeListElement) return;
    
    storeListElement.innerHTML = '';
    
    // If no nearby stores, show message
    if (nearbyStores.length === 0) {
      storeListElement.innerHTML = 
        '<div class="store-list-loading">No stores found within 100 miles of your search location.</div>';
      return;
    }
    
    // Create bounds for auto-zooming
    const bounds = L.latLngBounds();
    bounds.extend([searchLocation.lat, searchLocation.lng]); // Include search location
    
    // Add each store to map and list
    nearbyStores.forEach((store, index) => {
      // Create marker on map
      const marker = createMarker(store, index);
      markerClusterGroup.addLayer(marker);
      markers.push(marker);
      
      // Add to list with distance
      addStoreToListWithDistance(store, index);
      
      // Extend bounds to include this store
      bounds.extend([store.lat, store.lng]);
    });
    
    // Fit map to all markers plus search location
    if (map) {
      map.fitBounds(bounds, { padding: [30, 30] });
    }
  } catch (error) {
    console.error("Error displaying stores with distance:", error);
    const storeListElement = document.getElementById('store-list');
    if (storeListElement) {
      storeListElement.innerHTML = 
        '<div class="store-list-loading">Error calculating store distances.</div>';
    }
  }
}

// Add a store to the list with distance
function addStoreToListWithDistance(store, index) {
  try {
    const storeListElement = document.getElementById('store-list');
    if (!storeListElement) return;
    
    // Create Google Maps directions URL
    const directionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
      `${store.address}, ${store.city}, ${store.state} ${store.zip}`
    )}`;
    
    const storeItem = document.createElement('div');
    storeItem.className = 'store-item';
    storeItem.id = `store-item-${index}`;
    
    // Format distance nicely
    const distance = store.distance.toFixed(1);
    
    storeItem.innerHTML = `
      <h3>${store.name} <span class="store-distance">(${distance} miles)</span></h3>
      <p>${store.address}<br>${store.city}, ${store.state} ${store.zip}</p>
      ${store.phone ? `<p>Phone: ${store.phone}</p>` : ''}
      ${store.website ? `<p><a href="${store.website}" target="_blank">Visit Website</a></p>` : ''}
      <p><a href="${directionsUrl}" target="_blank" class="directions-button">Get Directions</a></p>
    `;
    
    // Add click event to list item
    storeItem.addEventListener('click', function() {
      // Remove active class from all items
      document.querySelectorAll('.store-item').forEach(item => {
        item.classList.remove('active');
      });
      
      // Add active class to clicked item
      storeItem.classList.add('active');
      
      // Center map on this store
      if (map) {
        map.setView([store.lat, store.lng], 14);
      }
      
      // Open marker popup
      if (markers.length > index) {
        markers[index].openPopup();
      }
    });
    
    storeListElement.appendChild(storeItem);
  } catch (error) {
    console.error(`Error adding store ${store.name} to list with distance:`, error);
  }
} 